<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <el-input
          v-model="search"
          style="width: 250px;max-height: 32px;"
          placeholder="Izlash"
          clearable
          @clear="onSearch"
      >
        <template #append>
          <el-button style="display: flex" @click="onSearch"
          ><img src="@/assets/images/icons/search.svg" alt=""/>
          </el-button>
        </template>
      </el-input>
      <el-select
          placeholder="Viloyatlar"
          v-model="region_id"
          @change="onChangeRegion"
          :loading="loading"
      >
        <el-option value="" label="Barchasi" />
        <el-option
            v-for="region in regions"
            :key="region.id"
            :value="region.id"
            :label="region.title"
        />
      </el-select>
      <el-select
          placeholder="Tuman/Shaxar"
          v-model="district_id"
          :loading="loading"
          @change="getModeratorsList"
      >
        <el-option value="" label="Barchasi" />

        <el-option
            v-for="district in districts"
            :key="district.id"
            :value="district.id"
            :label="district.title"
        />
      </el-select>
      <el-select style="" v-model="selectedRole">
        <el-option
            v-for="role in roles"
            :key="role.id"
            :value="role.id"
            :label="role.title"
        />
      </el-select>
      <el-upload
          ref="uploadRef"
          class="upload-demo"
          :action="excelUrls[selectedRole]"
          :headers="uploadHeader"
          :data="form"
          :multiple="false"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          :limit="1"
          :on-exceed="onExceed"
          :on-success="onSuccessUpload"
          :on-error="onErrorUpload"
      >
        <template #trigger>
          <el-button style="width: 100%" type="primary">
            {{
              selectedRole === 'region_manager' ? 'Region' : selectedRole === 'quarter_manager' || selectedRole === 'quarter_moderator' ? 'Mahalla' : 'Tuman'
            }} Moderatorlarni Excel orqali kiritish
          </el-button>
        </template>
      </el-upload>

      <el-button type="success" @click="downloadFile"
      ><img
          src="@/assets/images/icons/download.svg"
          alt=""
          style="margin-right: 5px"
      />
        {{
          selectedRole === 'region_manager' ? 'Region' : selectedRole === 'quarter_manager' || selectedRole === 'quarter_moderator' ? 'Mahalla' : 'Tuman'
        }}
        Moderatorlar listini yuklab olish
      </el-button>
      <el-select v-model="status_filter" placeholder="Holat" clearable @change="getModeratorsList">
        <el-option label="Faol"       :value="1" />
        <el-option label="Nofaol"     :value="2" />
        <el-option label="Bloklangan" :value="3" />
        <el-option label="Jarayonda"  :value="4" />
      </el-select>

      <el-button
          class="custom-btn"
          @click="() => this.$router.push({ name: 'RegionModeratorAdd' })"
          type="primary"
      >Qo'shish
      </el-button
      >
    </div>
    <el-table :data="moderators" border height="calc(100vh - 210px)">
      <el-table-column type="index"/>
      <el-table-column prop="fullname" label="Ismi Sharifi" min-width="250"/>
      <el-table-column prop="region_title" label="Viloyat" min-width="200"/>
      <el-table-column prop="district_title" label="Tuman" min-width="200"/>
      <el-table-column
          prop="last_login_date"
          label="So'nggi kirish vaqti"
          min-width="150"
      >
        <template v-slot="scope">
          {{ scope.row.last_login_date && $moment(scope.row.last_login_date).format("DD-MM-YYYY / HH:MM") }}
        </template>
      </el-table-column>
      <el-table-column prop="pinfl" label="Pinfl" min-width="150"/>
      <el-table-column label="Holat" min-width="130">
        <template #default="scope">
          <el-tag :type="statusTagType(scope.row.status)" effect="light">
            {{ statusLabel(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="320" label="Amallar">
        <template #default="scope">
          <el-button size="small" @click="onEditModerator(scope.row.id)" type="primary">Tahrirlash</el-button>
          <el-button size="small" @click="onDeleteModerator(scope.row.id)" type="danger">O'chirish</el-button>
          <el-button
            v-if="$store.state.role === 'admin'"
            size="small"
            type="info"
            @click="showHistory(scope.row.id)"
          >Holat tarixi</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog v-model="historyDialog" title="Holat tarixi" width="800px">
      <div v-loading="historyLoading">
        <el-table :data="historyData" border size="small">
          <el-table-column label="Sana" min-width="140">
            <template #default="scope">{{ $moment(scope.row.changed_at).format("DD-MM-YYYY HH:mm") }}</template>
          </el-table-column>
          <el-table-column label="Oldingi holat" min-width="120">
            <template #default="scope">
              <el-tag :type="statusTagType(scope.row.old_status)" size="small" effect="light">{{ statusLabel(scope.row.old_status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="Yangi holat" min-width="120">
            <template #default="scope">
              <el-tag :type="statusTagType(scope.row.new_status)" size="small" effect="light">{{ statusLabel(scope.row.new_status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="changed_by_fullname" label="Kim o'zgartirdi" min-width="160" />
          <el-table-column prop="reason" label="Sabab" min-width="160" />
        </el-table>
      </div>
    </el-dialog>
    <div class="pagination">
      <div>Region Moderatorlar soni: {{ totalCount }}</div>
      <el-pagination
          background
          layout="sizes, prev, pager, next"
          :total="totalCount"
          v-model:page-size="limit"
          v-model:current-page="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";

export default {
  name: "ModeratorsList",
  data() {
    return {
      uploadUrl: `${process.env.VUE_APP_BASE_API_URL}api/v1/users/region-managers-sync`,
      uploadHeader: {Authorization: `${this.$store.state.accessToken}`},

      form: {
        board_id: null,
      },
      loading: false,
      regionsLoading: false,
      districtsLoading: false,
      totalCount: 0,
      limit: 20,
      currentPage: 1,
      region_id: null,
      district_id: null,
      regions: [],
      districts: [],
      moderators: [],
      historyDialog: false,
      historyLoading: false,
      historyData: [],
      roles: [
        {title: "Viloyat boshqaruvi", id: "region_manager"},
        {title: "Tuman boshqaruvi", id: "district_manager"},
        {title: "Mahalla boshqaruvi", id: "quarter_manager"},
        {title: "Mahalla moderatori", id: "quarter_moderator"}
      ],
      selectedRole: "region_manager",
      excelUrls: {
        region_manager: `${process.env.VUE_APP_BASE_API_URL}api/v1/users/region-managers-sync`,
        district_manager: `${process.env.VUE_APP_BASE_API_URL}api/v1/district-managers/sync-excel`,
        quarter_manager: `${process.env.VUE_APP_BASE_API_URL}api/v1/quarter-managers/excel`,
        quarter_moderator: `${process.env.VUE_APP_BASE_API_URL}api/v1/quarter-moderators/sync-excel`,
      },
      search: null,
      status_filter: null,
    };
  },
  watch: {
    selectedRole() {
      this.getModeratorsList()
    }
  },
  methods: {
    showHistory(id) {
      this.historyData = [];
      this.historyDialog = true;
      this.historyLoading = true;
      this.$http.get(`/api/v1/managers/${id}`)
        .then(({ data }) => { this.historyData = data.status_history || []; })
        .catch(() => {})
        .finally(() => { this.historyLoading = false; });
    },
    statusLabel(status) {
      const map = { 1: "Faol", 2: "Nofaol", 3: "Bloklangan", 4: "Jarayonda" };
      return map[status] || "-";
    },
    statusTagType(status) {
      const map = { 1: "success", 2: "danger", 3: "danger", 4: "warning" };
      return map[status] || "info";
    },
    onChangeRegion(){
      this.districts=[];
      this.district_id=null;
      this.getDistricts();
    },
    getRegions() {
      this.currentPage = 1;
      this.$router.replace({query: {...this.$route.query, page: 1}});
      this.$http
          .get(`api/v1/regions`)
          .then(({ data }) => {
            this.regions = data.regions;
            this.getDistricts();
          })
          .catch((err) => {
            console.error("quarters fetch error", err);
          });
    },
    getDistricts() {
      this.currentPage = 1;
      this.$router.replace({query: {...this.$route.query, page: 1}});
      this.$http
          .get(`api/v1/districts`, {
            params: {
              region_id: this.region_id,
            },
          })
          .then(({ data }) => {
            this.districts = data.districts;
          })
          .catch((err) => {
            console.error("quarters fetch error", err);
          });
    },
    onSuccessUpload() {
      this.loading = false;
      ElNotification.success({
        message: "Amaliyot muvaffaqiyatli bajarildi!",
      });
      this.getModeratorsList();
    },
    onErrorUpload(error) {
      if (error.status === 401) {
        this.$store.commit("signOut");
        this.$router.push({name: "Auth"});
      }
      ElNotification.error({
        message:
            JSON.parse(error?.message)?.message ||
            "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
        type: "error",
      });

      this.loading = false;
    },
    onExceed(files) {
      console.log("exceeds", files);
      // this.form.file[0] = files[0]
    },
    downloadFile() {
      this.loading = true;
      let url;

      if (this.selectedRole === 'region_manager') {
        url = `api/v1/users/region-managers/excel`
      } else if (this.selectedRole === 'district_manager') {
        url = `api/v1/district-managers/excel`
      } else if (this.selectedRole === 'quarter_moderator') {
        url = `api/v1/quarter-moderators/excel`
      } else {
        url = `api/v1/quarter-managers/excel`
      }

      this.$http
          .get(url, {
            responseType: "blob",
          })
          .then((res) => {
            const url = URL.createObjectURL(
                new Blob([res.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
                })
            );
            const header = res.headers.get("Content-Disposition");
            const parts = header.split(";");
            let fileName = parts[1].split("=")[1];
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(({response}) => {
            ElNotification({
              title: "Ogohlantirish",
              message:
                  response.data.message ||
                  "Ma'lumot yuklashda xatolik sodir bo'ldi!",
              type: "warning",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onEditModerator(id) {
      this.$router.push({name: "RegionModeratorEdit", params: {id}});
    },
    onDeleteModerator(id) {
      ElMessageBox.confirm("Region Moderatorni o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
          .then(() => {
            this.loading = true;
            this.$http
                .delete(`/api/v1/managers/${id}`)
                .then(() => {
                  ElMessage({
                    type: "success",
                    message: "Viloyat moderator o'chirildi",
                  });
                  this.getModeratorsList();
                })
                .catch(() => {
                  ElNotification({
                    type: "error",
                    title: "Xatolik",
                    message: "Iltimos, qayta urinib ko'ring",
                  });
                })
                .finally(() => {
                  this.loading = false;
                });
          })
          .catch(() => {
            ElMessage({
              type: "info",
              message: "O'chirish bekor qilindi",
            });
          });
    },

    getModeratorsList() {
      this.loading = true;
      this.$http
          .get("/api/v1/managers", {
            params: {
              role: this.selectedRole,
              search: this.search,
              status: this.status_filter,
              region_id: this.region_id,
              district_id: this.district_id,
              limit: this.limit,
              offset: this.limit * (this.currentPage - 1),
            },
          })
          .then(({data}) => {
            this.moderators = data.users;
            this.totalCount = data.count;
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    indexMethod(index) {
      return index + (this.currentPage - 1) * this.limit + 1;
    },
    handleCurrentChange() {
      this.$router.replace({
        query: {...this.$route.query, page: this.currentPage},
      });
      this.getModeratorsList();
    },
    handleSizeChange() {
      this.$router.replace({
        query: {...this.$route.query, size: this.limit, page: 1},
      });
      this.currentPage = 1;
      this.getModeratorsList();
    },
    onSearch() {
      this.currentPage = 1;
      this.$router.replace({query: {...this.$route.query, page: 1}});
      this.getModeratorsList();
    },
  },
  mounted() {
    this.getRegions();
    this.getModeratorsList();
    if (this.$route.query.size) {
      this.limit = parseInt(this.$route.query.size);
    }
    if (this.$route.query.page) {
      this.currentPage = parseInt(this.$route.query.page);
    }
  },
};
</script>

<style scoped>
.header {
  display: flex;
  margin-bottom: 10px;
  gap: 10px;
  justify-content: flex-end;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
</style>
